import { EquipmentAuditStatus } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { EQUIPMENT_AUDIT_STATUS_LABEL_MAP } from 'noddi-util';
import { EQUIPMENT_AUDIT_STATUS_ICON } from './EquipmentStatusIcon';

const VARIANT_BY_STATUS = {
  [EquipmentAuditStatus.ACTIVE]: 'info',
  [EquipmentAuditStatus.COMPLETED]: 'success',
  [EquipmentAuditStatus.CANCELLED]: 'outline'
} as const;

export const EquipmentAuditStatusBadge = ({ status }: { status: EquipmentAuditStatus }) => (
  <NoddiBadge variant={VARIANT_BY_STATUS[status]}>
    <NoddiIcon name={EQUIPMENT_AUDIT_STATUS_ICON[status]} size='small' />
    {EQUIPMENT_AUDIT_STATUS_LABEL_MAP[status]}
  </NoddiBadge>
);
